import Vue from 'vue'
import authorizeUtils from '../../util/authorizeUtils'

const authorization = {
  state: {
    accessToken: '',
    // 设置的令牌60秒后清除
    expiry: 60000
  },
  mutations: {
    setAccessToken: function (state, value) {
      state.accessToken = value
      setTimeout(() => {
        state.accessToken = ''
      }, state.expiry)
    }
  },
  getters: {
    getAccessToken: function (state) {
      return state.accessToken
    }
  },
  actions: {
    loadAuthorization: function (context) {
      // 返回获取授权的promise
      const promise = new Promise((resolve, reject) => {
        if (context.state.accessToken) {
          resolve()
          return
        }
        const accessTokenKey = authorizeUtils.getAccessTokenKey()
        const accessToken = Vue.cookies.get(accessTokenKey)
        if (accessToken) {
          // 初始化access_token
          context.commit('setAccessToken', accessToken)
          resolve()
        } else {
          const refreshTokenKey = authorizeUtils.getRefreshTokenKey()
          const refreshToken = Vue.cookies.get(refreshTokenKey)
          if (refreshToken) {
            // 通过refresh_token刷新access_token
            Vue.prototype.$ajax({
              url: '/ws/student/refreshToken',
              method: 'post',
              data: Vue.prototype.$qs.stringify(authorizeUtils.wrapParams({
                refreshToken: refreshToken
              }))
            }).then((result) => {
              let resultData = result['data']
              if (resultData) {
                if (resultData['responseCode'] === 'SUCCESS') {
                  const refreshAccessToken = Vue.cookies.get(accessTokenKey)
                  if (refreshAccessToken) {
                    context.commit('setAccessToken', refreshAccessToken)
                    resolve()
                  } else {
                    reject(new Error('无法获取生成后的令牌'))
                  }
                } else {
                  reject(new Error(resultData['message'] || '无法刷新令牌'))
                }
              } else {
                reject(new Error('返回数据为空'))
              }
            }, () => {
              reject(new Error('无法访问远程服务器'))
            })
          } else {
            reject(new Error('用户授权信息已过期'))
          }
        }
      })
      return promise
    }
  }
}

export default authorization



// WEBPACK FOOTER //
// ./src/store/modules/authorization.js